import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Paper,
  Typography,
} from "@mui/material";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";

const PANEL_SX = {
  bgcolor: "background.paper",
  borderColor: "divider",
};

/**
 * Card chrome for the engine workspace. Renders as an outlined card on desktop
 * and as an accordion when the caller stacks panels on narrow screens, so the
 * panel bodies never have to know about the layout.
 */
const TriviaEnginePanel = ({
  title,
  collapsible = false,
  defaultExpanded = false,
  children,
}) => {
  if (collapsible) {
    return (
      <Accordion
        component="section"
        aria-label={title}
        variant="outlined"
        disableGutters
        defaultExpanded={defaultExpanded}
        sx={{ ...PANEL_SX, "&:before": { display: "none" } }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="subtitle1" fontWeight={800}>
            {title}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>{children}</AccordionDetails>
      </Accordion>
    );
  }

  return (
    <Paper
      component="section"
      aria-label={title}
      variant="outlined"
      sx={{ ...PANEL_SX, p: 2 }}
    >
      <Box sx={{ mb: 1.5 }}>
        <Typography variant="subtitle1" fontWeight={800}>
          {title}
        </Typography>
      </Box>
      {children}
    </Paper>
  );
};

export default TriviaEnginePanel;
